module.exports = __webpack_public_path__ + "img/project-banner4.2725dc86.jpg";